import {post,get} from '../../libs/ajax.js'

export default { 

    // 模板左侧-数据维度数据指标
    getPageAllowAction: (data, options) => {
        return post('/get_page_allow_action', data, options)
    },
    // 角色权限保存-修改
    postRoleEdit: (data, options) => {
        return post('/role/edit', data, options)
    },
    // 模板 筛选
    postTemplateCondition: (data, options) => {
        return post('/daily_task/template/get_condition', data, options)
    },
    // 模板创建 
    // http://localhost:9000/td/api/daily_task/template/get?plat_id=8&template_id=13
    postTempleateAdd: (data, options) => {
        return post('/daily_task/template/add', data, options)
    },
    // 模板详情
    getTempleateInfo: (data, options) => {
        return get('/daily_task/template/get', data, options)
    },
    // 模板详情
    postTempleateEdit: (data, options) => {
        return post('/daily_task/template/edit', data, options)
    }
}
 

